import { lockScroll, unlockScroll } from '@js4y/lock-scroll';
import { createFocusTrap } from 'focus-trap';
import Swiper from 'swiper/bundle';
import {
  updateSwiperStatus,
  updateSlidesInert,
} from '../utils/accessibility-swiper';

class TextPopupManager {
  constructor() {
    this.attrs = {
      trigger: 'data-text-popup',
      target: 'data-text-popup-target',
      button: 'data-text-popup-index',
      tab: 'data-text-popup-tab',
    };

    this.classes = {
      active: 'is-active',
      visible: 'is-visible',
    };

    this.sections = document.querySelectorAll(`[${this.attrs.trigger}]`);
    this.activeFocusTrap = null;
    this.textPopupSwiper = null;

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  init() {
    if (!this.sections.length) return;

    this.bindSectionButtons();
    this.initSwiper();

    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  initSwiper() {
    this.textPopupSwiper = new Swiper('.text-popup__tab-slider', {
      slidesPerView: 1,
      spaceBetween: 60,
      watchSlidesProgress: true,

      navigation: {
        nextEl: '.text-popup-next',
        prevEl: '.text-popup-prev',
      },

      a11y: {
        enabled: true,
        slideLabelMessage: '',
        nextSlideMessage:
          Shopify.locale === 'uk' ? 'Наступний слайд' : 'Следующий слайд',
        prevSlideMessage:
          Shopify.locale === 'uk' ? 'Попередній слайд' : 'Предыдущий слайд',
      },

      on: {
        init(swiper) {
          setTimeout(() => {
            swiper.slides.forEach((slide) => {
              slide.removeAttribute('role');
            });

            updateSlidesInert(swiper, 'active');
          }, 0);

          updateSwiperStatus(swiper);
        },

        slideChange(swiper) {
          updateSwiperStatus(swiper);
          updateSlidesInert(swiper, 'active');
        },

        resize(swiper) {
          updateSwiperStatus(swiper);
          updateSlidesInert(swiper, 'active');
        },
      },
    });
  }

  bindSectionButtons() {
    this.sections.forEach((section) => {
      const popupId = section.getAttribute(this.attrs.trigger);
      if (!popupId) return;

      section.querySelectorAll(`[${this.attrs.button}]`).forEach((button) => {
        button.addEventListener('click', () => {
					const index = Math.max(
						0,
						Number(button.getAttribute(this.attrs.button)) - 1
					);
          this.open(popupId, index);
        });
      });
    });
  }

  getPopupWrapper(popupId = '') {
    return document.querySelector(`[${this.attrs.target}='${popupId}']`);
  }

	open(popupId = '', index = 0) {
		const popupWrapper = this.getPopupWrapper(popupId);
		if (!popupWrapper) return;
	
		this.deactivateFocusTrap();
	
		popupWrapper.classList.add(this.classes.active);
		popupWrapper.removeAttribute('inert');
	
		if (this.textPopupSwiper) {
			this.textPopupSwiper.update();
			this.textPopupSwiper.slideTo(index, 0);
			updateSwiperStatus(this.textPopupSwiper);
			updateSlidesInert(this.textPopupSwiper, 'active');
		}
	
		this.activeFocusTrap = createFocusTrap(popupWrapper, {
			allowOutsideClick: false,
			escapeDeactivates: false,
			fallbackFocus: popupWrapper,
		});
	
		this.activeFocusTrap.activate();
		lockScroll();
	}

	close() {
		const popupWrapper = document.querySelector(
			`.${this.classes.active}[${this.attrs.target}]`
		);
	
		if (!popupWrapper) return;
	
		this.deactivateFocusTrap();
	
		popupWrapper.classList.remove(this.classes.active);
		popupWrapper.setAttribute('inert', '');
	
		unlockScroll();
	}

  deactivateFocusTrap() {
    if (!this.activeFocusTrap) return;

    this.activeFocusTrap.deactivate();
    this.activeFocusTrap = null;
  }

  handleDocumentClick(event = new MouseEvent('click')) {
    const { target } = event;
    if (!target || typeof target !== 'object') return;

    const closest = Reflect.get(target, 'closest');

    if (
      typeof closest === 'function' &&
      closest.call(target, '.js-close-text-popup')
    ) {
      this.close();
    }
  }

  handleKeydown(event = new KeyboardEvent('keydown')) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}

new TextPopupManager().init();